export const extractSlides = (vnodes) => {
  return vnodes.flatMap((vnode) =>
    isSlide(vnode)
      ? [vnode]
      : Array.isArray(vnode.children) && vnode.children.length > 0
        ? extractSlides(vnode.children)
        : []
  );
};

function isSlide(vnode) {
  return !vnode.type.toString().startsWith('Symbol');
}
